angular.module('bmsApp.fees')
	.controller('FeeBreakdownModalCtrl', FeeBreakdownModalCtrl);

FeeBreakdownModalCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'fee',
	'$modalInstance',
	'FeeSvc',
];

function FeeBreakdownModalCtrl($scope, $state, $q, fee, $modalInstance, FeeSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		breakdown: {},
	});



	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.onInit = () => {
		FeeSvc.breakdown(fee).then((response) => {
			self.breakdown = response.data.collection;
		});
	};

	handlers.onCancel = () => {
		$modalInstance.dismiss('cancel');
	};


}